import { ManagerOption } from '@components/Stats/Navigation/AccountManagerSelect';
import { AccountManager, Pod } from '@components/Users/slice/schema';

type ValuesProps = {
  accountManagerIds: number[];
  podIds: number[];
  accountManagers: AccountManager[];
  pods: Pod[];
};

export const values = (props: ValuesProps) => {
  const accountManagerValues: ManagerOption[] = props.accountManagerIds.map(
    accountManagerId => ({
      id: accountManagerId,
      groupLabel: 'User',
      label:
        props.accountManagers.find(manager => manager.id === accountManagerId)
          ?.fullName ?? 'Unknown',
    })
  );
  const podManagerValues: ManagerOption[] = props.podIds.map(podId => ({
    id: podId,
    groupLabel: 'Pod',
    label: props.pods.find(pod => pod.id === podId)?.name ?? 'Unknown',
  }));

  return [...accountManagerValues, ...podManagerValues];
};
